<template>
	<div>
		<div class="header">
			<div class="info-iconfont">
				<router-link to="/UserInfo">
					<van-icon color="#FFF" size="22px" name="setting-o" />
				</router-link>
			</div>
			<van-row style="padding: 50px 0px 5px 15px;display: flex;justify-content: center;align-items: center;">
				<van-col span="6" style="text-align: center">
					<img style="width: 60px;height: 60px;border-radius: 60px;border: 2px snow solid;box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);" 
					:src="getimg(usinfo.tx)" />
				</van-col>
				<van-col span="13" style="color: #fff">
					<van-col span="24" style="font-size: 20px">
						{{ userid }}
					</van-col>
					<van-col span="24" style="font-size: 12px; margin-top: 10px; margin-bottom: 10px">
						<van-tag v-if="usinfo.ulevelName" color="#eabc45">{{ usinfo.ulevelName }}</van-tag>
						<span v-if="usinfo.xlevel > 0" style="padding-left: 5px">
							<van-tag color="#eabc45">{{ usinfo.xlevelName }}</van-tag>
						</span>
					</van-col>
				</van-col>
				<van-col span="5" style="text-align: right;padding-right: 15px;">
					<img src="../../assets/img/ewm.png" style="width: 35px;" @click="toQrcode"/>
				</van-col>
			</van-row>
			<van-row>
				<van-notice-bar background="#fff0" left-icon="" style="margin: 0 10px;color: #FBF6ED;" :text="marqueemsg" />
			</van-row>

			
			</div>
			<div class="cardBox" style="margin-top: 5px;">
				<div class="cardContent a">
					<van-cell title="我的订单" is-link to="Order" value="全部" />
					<van-grid :border="false" :column-num="3">
						<van-grid-item icon="underway" :badge="ordernum[0] === 0 ? '' : ordernum[0]" to="Order?state=0"
							text="待支付" />
						<van-grid-item icon="send-gift" :badge="ordernum[1] === 0 ? '' : ordernum[1]" to="Order?state=1"
							text="待发货" />
						<van-grid-item icon="bag" :badge="ordernum[2] === 0 ? '' : ordernum[2]" to="Order?state=2"
							text="待收货" />
						<!-- <van-grid-item
			                icon="notes-o"
			                :badge="ordernum[3] === 0 ? '' : ordernum[3]"
			                to="Order?state=3"
			                text="已收货"
			            /> -->
					</van-grid>
				</div>
		</div>

		<div class="tool-wrap">
		<!-- 	<div id="coll" v-if="fanli">
				
				<van-collapse v-model="activeNames">
				 
				  <van-collapse-item title="消费返利" name="2" icon="diamond" >
				    <van-row style="text-align: center;color: #777;">
						<van-col span="10">返利时间</van-col>
						<van-col span="7">	总消费</van-col>
						<van-col span="7">已返利</van-col>
						
						<van-col span="10"  style="font-weight: bold;padding-top: 10px;color: #444">{{fanli.sdate}}</van-col>
						<van-col span="7" style="font-weight: bold;padding-top: 10px;color: #444">	{{fanli.zjine}}</van-col>
						<van-col span="7"  style="font-weight: bold;padding-top: 10px;color: #444">{{fanli.fjine}}</van-col>
						
					</van-row>
				  </van-collapse-item>
				</van-collapse>
			</div> -->
			<div class="tool-item" @click="tolink('Gufen')">
				<div>
					<img src="@/assets/img/user/up.svg" width="16" />
					<span>股份</span>
				</div>
				<van-icon name="arrow" color="gray" />
			</div>
			
			
			<div class="tool-item" @click="toQrcode">
				<div>
					<img src="@/assets/img/user/qr.svg" width="16" />
					<span>分享</span>
				</div>
				<van-icon name="arrow" color="gray" />
			</div>
			<!-- <div class="tool-item" @click="tolink('Register')">
				<div>
					<img src="@/assets/img/user/zc.svg" width="16" />
					<span>注册</span>
				</div>
				<van-icon name="arrow" color="gray" />
			</div> -->
			<div class="tool-item" @click="tolink('Tree')" v-if="switchtjt == 1">
				<div>
					<img src="@/assets/img/user/td.svg" width="16" />
					<span>团队</span>
				</div>
				<van-icon name="arrow" color="gray" />
			</div>
			<div class="tool-item" @click="tolink('Msg')">
				<div>
					<img src="@/assets/img/user/xx.svg" width="16" />
					<span>消息</span>
				</div>
				<van-icon name="arrow" color="gray" />
			</div>
			<div class="tool-item" @click="tolink('News')">
				<div>
					<img src="@/assets/img/user/xw.svg" width="16" />
					<span>新闻公告</span>
				</div>
				<van-icon name="arrow" color="gray" />
			</div>
			
			
			<div class="tool-item" @click="tolink('Question')">
				<div>
					<img src="@/assets/img/user/wt.svg" width="16" />
					<span>常见问题</span>
				</div>
				<van-icon name="arrow" color="gray" />
			</div>
		</div>

		<div class="footer">
			<van-button style="background-color: #FAC363; color: #fff;" block @click="logout">退出登录</van-button>
		</div>



		<Login></Login>
		<BottomBar></BottomBar>
	</div>
</template>

<script>
	import Login from "@/components/Login";
	import BottomBar from "@/components/BottomBar";

	import Vue from "vue";
	import {
		Grid,
		GridItem
	} from "vant";
	import {
		Cell,
		CellGroup,
		Tag,
		NoticeBar
	} from "vant";
import { Collapse, CollapseItem } from 'vant';
	Vue.use(Cell);
	Vue.use(CellGroup);
	Vue.use(Grid);
	Vue.use(GridItem);
	Vue.use(Tag);
	Vue.use(NoticeBar);
	Vue.use(Collapse);
	Vue.use(CollapseItem);

	export default {
		name: "user",
		components: {
			Login,
			BottomBar,
		},
		data() {
			return {
				active: "",
				userid: "您还没有登录,请先登录.",
				usinfo: {},
				ordernum: {},
				msgCount: 0,
				marqueemsg: "",
				defaulttx: require("../../assets/img/tx2.png"),
				walletList: [],
				switchtjt: "",
				activeNames:["1"],
				fanli: "",
			};
		},
		created() {
			this.load();
		},
		methods: {
			load: function() {
				//登录组件登录成功后会触发该函数,刷新父窗体数据
				if (this.$store.state.LoginState) {
					//子组件调用加载
					this.getdata();
					this.getordernum();
					 this.getgg();
					this.getWallet();
					//this.getfanli();
				}
			},
			getimg: function(imgname) {
				let path = this.$config.send_url + "Upload/" + imgname;
				if (typeof imgname == "undefined") {
					path = this.defaulttx;
				}
				return path;
			},
			getdata: function() {
				var _this = this;
				_this.$request.post(
					"api/Users/Get", {
						token: _this.$utils.getloc("token"),
						userid: _this.$utils.getloc("userid"),
					},
					(res) => {
						if (res.data.code == 0) {
							_this.$dialog.alert({
								title: "提示",
								message: res.data.msg,
							});
							return;
						}
						var data = res.data.data;
						_this.usinfo = data.us;

						_this.userid = _this.usinfo.userid;
						_this.msgCount = data.msgcount;
						_this.switchtjt = data.systemSetting.switchtjt
					}
				);
			},
			
			getordernum: function() {
				var _this = this;
				_this.$request.post(
					"api/ShopOrder/Allordernum", {
						token: _this.$utils.getloc("token"),
						userid: _this.$utils.getloc("userid"),
					},
					(res) => {
						if (res.data.code == 0) {
							_this.$dialog.alert({
								title: "提示",
								message: res.data.msg,
							});
							return;
						}
						_this.ordernum = res.data.data;
					}
				);
			},
			logout: function() {
				this.$utils.setloc("token", "");
				this.$store.commit("setLoginState", false);
				location.reload();
			},
			getgg: function() {
				var _this = this;
				_this.$request.post("Api/News/Gonggao", {}, (res) => {
					if (res.data.code == 0) {
						_this.$dialog.alert({
							title: "提示",
							message: res.data.msg,
						});
						return;
					}
					_this.marqueemsg = res.data.data;
				});
			},
			tolink: function(path) {
				this.$router.push({
					name: path,
				});
			},
			toQrcode() {
				this.$router.push({
					path: "Qrcode",
					query: {
						recode: this.usinfo.recode,
						username: this.usinfo.username,
						tx: this.usinfo.tx,
					}
				})
			},
			getWallet() {
				let that = this
				that.$request.post("api/Wallets/GetWallet", {
						token: that.$utils.getloc("token"),
						userid: that.$utils.getloc("userid"),
						id: that.$utils.getloc("id"),
					},
					(res) => {
						if (res.data.code == 0) {
							that.$dialog.alert({
								title: "提示",
								message: res.data.msg,
							});
							return;
						}
						that.walletList = res.data.data
					}
				)
			}
		},
	};
</script>

<style scoped>
	.header {
		position: relative;
		height: 180px;
		background: url(../../assets/img/user/user-header.png) bottom no-repeat,
			linear-gradient(270deg, #574AA5, #574AA5, #574AA5, #574AA5);
		background-size: 100%;
	}

	.info-iconfont {
		position: absolute;
		right: 15px;
		top: 15px;
	}

	.footer {
		height: 100px;
		padding: 10px;
		/* position: fixed;	 */
		/* bottom: 0; */

	}
	
	#coll /deep/.van-cell{
		padding: 10px 0px;
	}

	/deep/.van-cell__value {
		font-size: 14px;
		
		
	}

	/deep/.van-cell__left-icon {
		font-size: 18px;
		padding-right: 4px;
		color: blue;
	}

/deep/.van-cell__right-icon{
	color: gray;
}

	/deep/.van-icon-underway::before,
	/deep/.van-icon-send-gift::before,
	/deep/.van-icon-bag::before {
		color: #EE8B83;
	}

	.a /deep/.van-cell {
		padding: 5px 16px;
	}

	/deep/.topbtn .van-grid-item__content {
		background-color: transparent;
	}

	/deep/.topbtn .van-grid-item__icon {
		color: #fff;
	}

	/deep/.topbtn .van-icon-underway::before,
	/deep/.topbtn .van-icon-send-gift::before,
	/deep/.topbtn .van-icon-invition::before {
		color: #fff;
	}

	/deep/.topbtn .van-grid-item__text {
		color: #fff;
	}

	/deep/ .van-notice-bar {
		font-size: 13px;
		color: rgb(88, 81, 81);
	}

	/deep/ .van-notice-bar .van-icon {
		color: #FE609D;
	}

	.fuwu-box {
		color: #646566;
		font-size: 12px;
		line-height: 1.5;
	}

	.fuwu-box .van-col {
		padding: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.fuwu-box img {
		width: 28px;
		height: 28px;
		margin-bottom: 6px;
	}

	.wallet {
		text-align: center;
		color: #fff;
		font-size: 13px;
	}

	.wallet .van-col {
		padding: 8px 0 10px;
	}

	.wallet-jine {
		font-size: 14px;
		font-weight: 600;
	}

	.tool-wrap {
		margin: 5px 10px 0;
		border-radius: 14px;
		background-color: #fff;
		padding: 10px;
	}

	.tool-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 0;
		border-bottom: 1px solid #f4f5f5;
	}

	.tool-item:last-child {
		border-bottom: 0;
	}

	.tool-item>div {
		display: flex;
		align-items: center;
	}

	.tool-item span {
		padding-left: 8px;
		font-size: 15px;
		color: #37416b;
	}
</style>
